import client from "./client";

const BASE = "/bonuses";

export const listBonuses = async (params = {}) => (await client.get(BASE, { params })).data;
export const pendingPayment = async (params = {}) => (await client.get(`${BASE}/pending-payment`, { params })).data;
export const pendingConfirmation = async (params = {}) =>
  (await client.get(`${BASE}/pending-confirmation`, { params })).data;
export const myBonuses = async () => (await client.get(`${BASE}/mine`)).data;
export const bonusReport = async (params = {}) => (await client.get(`${BASE}/monthly-report`, { params })).data;
export const getBonus = async (id) => (await client.get(`${BASE}/${id}`)).data;
export const createBonus = async (body) => (await client.post(BASE, body)).data;
export const approveBonus = async (id) => (await client.post(`${BASE}/${id}/approve`)).data;
export const payBonus = async (id) => (await client.post(`${BASE}/${id}/pay`)).data;
export const cancelBonus = async (id, reason) => (await client.post(`${BASE}/${id}/cancel`, { reason })).data;
export const confirmBonusReceipt = async (id, confirmed = true, note = null) =>
  (await client.post(`${BASE}/${id}/confirm-receipt`, { confirmed, note })).data;
export const updateBonusSource = async (id, body) => (await client.patch(`${BASE}/${id}`, body)).data;
export const sendBonusReminders = async () => (await client.post(`${BASE}/send-reminders`)).data;
export const bonusReportUrl = (params = {}) => {
  const query = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
  return `${BASE}/monthly-report/export?${query}`;
};
